<template>
  <div class="topup-progress">
    <ul>
      <li :class="{active: isStepActive(1)}">
        <span class="step-container">
          <span class="progress-line start"></span>
          <span class="step">
            <span v-if="isStepCompleted(1)">
              <font-awesome-icon :icon="['fas', 'check']" />
            </span>
            <span v-if="!isStepCompleted(1)">1</span>
          </span>
        </span>
        <span class="text" :class="{current: isCurrentStep(1)}" v-html="$t('component.progress.step1')"></span>
      </li>
      <li :class="{active: isStepActive(2)}">
        <span class="step-container">
          <span class="progress-line"></span>
          <span class="step">
            <span v-if="isStepCompleted(2)">
              <font-awesome-icon :icon="['fas', 'check']" />
            </span>
            <span v-if="!isStepCompleted(2)">2</span>
          </span>
        </span>
        <span class="text" :class="{current: isCurrentStep(2)}"  v-html="$t('component.progress.step2')"></span>
      </li>
      <li :class="{active: isStepActive(3)}">
        <span class="step-container">
          <span class="progress-line end"></span>
          <span class="step">
            <span>3</span>
          </span>
        </span>
        <span class="text" :class="{current: isCurrentStep(3)}" v-html="$t('component.progress.step3')"></span>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  name: 'RegisterProgress',
  props: {
    step: {
      type: Number,
      required: true
    }
  },
  methods: {
    isStepActive (step) {
      return this.step >= step
    },
    isStepCompleted (step) {
      return this.step > step
    },
    isCurrentStep (step) {
      return this.step === step
    }
  }
}
</script>

<style src="../../assets/scss/topup-progress.scss" lang="scss"></style>
